import React from "react";

const Augmento = () => {
  return (
  <>
    {process.env.REACT_APP_VDC_PLATFORM === "true" && 
      <img src={`${window.location.origin}/images/VDC_Topbar_LightTheme_Logo.svg`} alt="logo" style={{width:"92px",height:"21px"}}/>
    } 
    {process.env.REACT_APP_VDC_PLATFORM === "false" && 
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="111"
        height="25"
        viewBox="0 0 111 25"
        fill="none"
      >
        <g clipPath="url(#clip0_7338_219889)">
          <path
            d="M105.7 20H106.7V21.9L108.1 20H109.3L107.9 21.9L109.6 24.7H108.4L107.3 22.8L106.7 23.5V24.7H105.7V20Z"
            fill="#F58220"
          />
          <path
            d="M76.3002 20H77.6002C79.0002 20 79.9002 20.7 79.9002 22.3C79.9002 23.9 79.0002 24.6 77.6002 24.6H76.2002L76.3002 20ZM77.6002 23.8C78.4002 23.8 78.9002 23.4 78.9002 22.3C78.9002 21.2 78.3002 20.8 77.6002 20.8H77.4002V23.7L77.6002 23.8Z"
            fill="#00539C"
          />
          <path
            d="M81.7001 20H84.6001V20.9H82.7001V21.8H84.3001V22.7H82.7001V23.7H84.6001V24.6H81.6001L81.7001 20Z"
            fill="#00539C"
          />
          <path
            d="M86.4999 20H89.3999V20.9H87.4999V21.8H89.0999V22.7H87.4999V23.7H89.3999V24.6H86.3999L86.4999 20Z"
            fill="#00539C"
          />
          <path
            d="M91.2002 20H92.8002C93.8002 20 94.6002 20.3 94.6002 21.5C94.6002 22.7 93.7002 23 92.8002 23H92.2002V24.6H91.2002V20ZM92.8002 22.3C93.4002 22.3 93.6002 22 93.6002 21.5C93.6002 21 93.3002 20.8 92.7002 20.8H92.2002V22.2L92.8002 22.3Z"
            fill="#00539C"
          />
          <path
            d="M97.0999 20.9H95.8999V20H99.4999V20.9H98.2999V24.6H97.2999L97.0999 20.9Z"
            fill="#F58220"
          />
          <path
            d="M101 20H103.9V20.9H102V21.8H103.6V22.7H102V23.7H103.9V24.6H100.9L101 20Z"
            fill="#F58220"
          />
          <path
            d="M27.7 9.39987C27.7 9.29987 27.7 9.19988 27.7 9.09988C27.8 7.49988 28 5.89987 29.2 4.69987C30.3 3.59987 32 3.19988 33.5 3.19988C35 3.09988 36.6 3.29987 38.1 3.29987L38.2 13.2999C38.2 14.9999 38.2 16.7999 37.2 18.1999C36.3 19.3999 35 20.0999 33.5 20.1999C32.1 20.2999 30.7 20.0999 29.5 19.4999C29.4 19.4999 29.3 19.3999 29.3 19.3999C29.3 19.3999 29.4 19.2999 29.4 19.1999L29.8 18.7999L30.6 17.9999C30.7 17.8999 30.7 17.8999 30.8 17.8999C30.9 17.7999 31.1 17.7999 31.1 17.8999C31.8 18.0999 32.5 18.1999 33.2 17.9999C33.9 17.7999 34.5 17.4999 34.9 16.9999C35.3 16.1999 35.5 15.2999 35.5 14.3999C34.1 15.5999 32 15.9999 30.4 15.1999C29.4 14.5999 28.6 13.6999 28.3 12.5999C27.9 11.4999 27.6 10.3999 27.7 9.39987ZM30.3 9.69987C30.2 10.6999 30.5 11.6999 31 12.4999C31.4 13.1999 32.2 13.4999 33 13.4999C34 13.5999 35 12.8999 35.4 11.9999V6.89988C35 5.99988 34.1 5.49988 33 5.49988C32.2 5.49988 31.5 5.79988 31 6.49988C30.5 7.49988 30.3 8.59987 30.3 9.69987Z"
            fill="#00539C"
            stroke="#00539C"
            strokeWidth="0.5"
            strokeMiterlimit="10"
          />
          <path
            d="M82.4999 3.19922C84.9999 3.19922 86.1999 4.69922 86.2999 7.49922V15.3992H83.5999V7.69922C83.6999 7.09922 83.4999 6.49922 83.0999 5.99922C82.6999 5.59922 82.0999 5.39922 81.4999 5.39922C80.4999 5.39922 79.4999 5.99922 79.0999 6.89922V15.3992H76.3999L76.4999 3.29922C76.4999 3.29922 80.9999 3.19922 82.4999 3.19922Z"
            fill="#00539C"
            stroke="#00539C"
            strokeWidth="0.5"
            strokeMiterlimit="10"
          />
          <path
            d="M44.6002 3.39909L44.7002 4.59909C45.6002 3.59909 46.8002 3.09909 48.2002 3.09909C49.8002 3.09909 50.9002 3.69909 51.5002 4.99909C52.3002 3.79909 53.7002 3.09909 55.2002 3.09909C56.3002 2.99909 57.3002 3.39909 58.1002 4.19909C58.8002 5.09909 59.1002 6.29909 59.1002 7.39909V15.1991H56.4002V7.59909C56.4002 6.99909 56.2002 6.39909 55.8002 5.99909C55.3002 5.59909 54.8002 5.39909 54.1002 5.39909C53.5002 5.39909 53.0002 5.49909 52.6002 5.89909C52.2002 6.19909 51.9002 6.69909 51.8002 7.19909V15.2991H49.2002V7.49909C49.3002 6.49909 48.5002 5.49909 47.5002 5.39909C47.4002 5.39909 47.2002 5.39909 47.1002 5.39909C46.1002 5.29909 45.2002 5.89909 44.8002 6.69909V15.2991H42.2002V3.39909H44.6002Z"
            fill="#00539C"
            stroke="#00539C"
            strokeWidth="0.5"
            strokeMiterlimit="10"
          />
          <path
            d="M68.2 15.6006C66.7 15.7006 65.2 15.1006 64.1 14.0006C63 12.8006 62.4 11.3006 62.5 9.70063V9.30063C62.5 8.20063 62.7 7.10063 63.2 6.10063C63.6 5.20063 64.3 4.40063 65.1 3.90063C65.9 3.30063 66.9 3.10063 67.9 3.10063C69.4 3.00063 70.7 3.60063 71.7 4.70063C72.7 5.90063 73.2 7.50063 73.1 9.10063V10.2006H65.2C65.2 11.1006 65.5 11.9006 66.2 12.5006C66.8 13.1006 67.6 13.4006 68.4 13.3006C69.6 13.3006 70.7 12.7006 71.4 11.8006L72.9 13.2006C72.4 13.9006 71.7 14.5006 71 14.9006C70 15.4006 69.1 15.6006 68.2 15.6006ZM67.8 5.30063C67.1 5.30063 66.5 5.60063 66 6.10063C65.5 6.70063 65.2 7.50063 65.2 8.20063H70.3V8.00063C70.3 7.20063 70.1 6.50063 69.6 6.00063C69.1 5.50063 68.5 5.30063 67.8 5.30063Z"
            fill="#00539C"
            stroke="#00539C"
            strokeWidth="0.5"
            strokeMiterlimit="10"
          />
          <path
            d="M93.7001 0.5V3.4H95.8001V5.4H93.7001V12.1C93.7001 12.4 93.8001 12.8 94.0001 13.1C94.3001 13.3 94.6001 13.4 95.0001 13.4C95.3001 13.4 95.6001 13.3 96.0001 13.3V15.4C95.4001 15.5 94.8001 15.7 94.2001 15.7C92.1001 15.7 91.1001 14.6 91.1001 12.3V5.4H89.1001V3.4H91.1001V0.5H93.7001Z"
            fill="#00539C"
            stroke="#00539C"
            strokeWidth="0.5"
            strokeMiterlimit="10"
          />
          <path
            d="M98.5001 9.30024C98.5001 8.20024 98.7001 7.10024 99.2001 6.10024C99.6001 5.20024 100.3 4.40024 101.1 4.00024C102 3.50024 103 3.20024 104 3.20024C105.5 3.10024 106.9 3.70024 107.9 4.80024C108.9 5.90024 109.6 7.40024 109.6 8.90024V9.50024C109.6 10.6002 109.4 11.6002 108.9 12.7002C108.5 13.6002 107.8 14.4002 107 14.8002C106.1 15.3002 105.1 15.6002 104.1 15.6002C102.6 15.7002 101.1 15.0002 100 13.9002C99.0001 12.7002 98.4001 11.1002 98.5001 9.40024V9.30024ZM101.2 9.50024C101.1 10.5002 101.4 11.5002 102 12.4002C102.9 13.6002 104.6 13.8002 105.7 13.0002C105.9 12.9002 106 12.7002 106.3 12.4002C106.9 11.5002 107.1 10.4002 107.1 9.30024C107.2 8.30024 106.9 7.20024 106.3 6.40024C105.5 5.20024 103.8 5.00024 102.6 5.80024C102.4 5.90024 102.2 6.10024 102 6.40024C101.4 7.30024 101.1 8.40024 101.2 9.50024Z"
            fill="#00539C"
            stroke="#00539C"
            strokeWidth="0.5"
            strokeMiterlimit="10"
          />
          <path
            d="M21.8 14.7008C21 15.7008 19.7 16.2008 18.4 16.1008C17.3 16.2008 16.2 15.8008 15.4 15.0008C14.7 14.0008 14.3 12.9008 14.4 11.7008V3.80078H17.1V11.5008C17.1 13.0008 17.7 13.8008 19 13.8008C20.3 13.8008 21.2 13.3008 21.6 12.4008V3.80078H24.3V15.7008H21.7L21.8 14.7008Z"
            fill="#00539C"
            stroke="#00539C"
            strokeWidth="0.5"
            strokeMiterlimit="10"
          />
          <path
            d="M8.30008 15.5007C8.20008 15.1007 8.00008 14.7007 8.00008 14.3007C7.20008 15.2007 6.00008 15.7007 4.80008 15.7007C3.70008 15.8007 2.60008 15.4007 1.80008 14.7007C0.900084 14.0007 0.500084 13.0007 0.500084 12.0007C0.400084 10.9007 1.00008 9.70072 2.00008 9.00072C3.20008 8.20072 4.70008 7.80072 6.20008 8.00072H7.90008V7.10072C7.90008 6.50072 7.80008 6.00072 7.30008 5.60072C6.90008 5.10072 6.30008 4.90072 5.70008 5.00072C5.10008 5.00072 4.60008 5.10072 4.10008 5.50072C3.80008 5.70072 3.50008 6.20072 3.50008 6.60072H0.800084C0.800084 5.90072 1.10008 5.20072 1.50008 4.70072C2.00008 4.10072 2.60008 3.60072 3.30008 3.30072C4.10008 3.10072 5.00008 2.80072 5.90008 2.90072C7.10008 2.80072 8.40008 3.30072 9.30008 4.00072C10.2001 4.80072 10.7001 5.90072 10.6001 7.10072V12.7007C10.5001 13.6007 10.7001 14.5007 11.1001 15.4007V15.6007L8.30008 15.5007ZM5.30008 13.5007C5.90008 13.5007 6.40008 13.4007 6.80008 13.1007C7.30008 12.8007 7.60008 12.5007 7.90008 12.0007V9.60072H6.40008C5.50008 9.50072 4.80008 9.80072 4.00008 10.2007C3.50008 10.5007 3.20008 11.1007 3.20008 11.7007C3.20008 12.2007 3.30008 12.7007 3.80008 13.0007C4.20008 13.3007 4.70008 13.5007 5.30008 13.5007Z"
            fill="#00539C"
            stroke="#00539C"
            strokeWidth="0.5"
            strokeMiterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_7338_219889">
            <rect width="110.1" height="24.6" fill="white" />
          </clipPath>
        </defs>
      </svg>
    }
  </>
  );
};

export default Augmento;
